'use client'

import AppContext from "AppContext";
import GeneralForm from "components/GeneralForm";
import IconButton from "components/IconButton";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container, FormGroup, Input } from "reactstrap";
import { erroInesperado } from "services/Utils";
import veiculoService from "services/VeiculoService";

export default function FormVeiculo() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const params = useParams()
  const navigate = useNavigate()
  const { state } = useContext(AppContext)

  const podeGerenciar = (state?.user?.acoes || []).includes('veiculo.gerenciar')

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    if (!!id) {
      veiculoService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "marcaModelo", label: 'Marca e Modelo', type: "text", required: true, colspan: 8 },
        { name: "placa", label: 'Placa', type: "text", required: true, colspan: 4 },
        {
          name: "equipeAtual", colspan: 5, type: 'view', component: () => {
            return data.equipeAtual && (
              <div className="form-group">
                <label>Equipe Atual</label>
                <div style={{ border: '1px solid #ccc', padding: '5px 10px  ', borderRadius: 5, display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>{data.equipeAtual.nome}</span>
                  <IconButton alt="Editar Equipe" iconClass="bi-pencil-square" onClick={() => navigate("/admin/equipes/" + data.equipeAtual.id)} />
                </div>
              </div>
            )
          }
        },
      ]
    ]
  }, [data])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await veiculoService.create(data)
      } else {
        await veiculoService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/veiculos')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Veículos" edit={edit} onChangeEdit={setEdit} showButton={!novo && podeGerenciar} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary">Salvar</Button>
            )}
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}